import React from "react";
import { useAuth } from "react-oidc-context";
import {
  Container,
  ContentLayout,
  Header,
  SpaceBetween,
} from "@amzn/awsui-components-react-v3/polaris";
import { PageLayout } from "../components/page-layout";
import { useSetBadgePin } from "../hooks/pin";
import { PinForm } from "../components/pin-form";
import { Alerts } from "../components/alerts";
import { Alerts as AlertsType } from "../lib/types";
import { RegistrationMessages } from "../lib/constants";
import { BADGE_PIN_PRESET } from "../lib/pin-presets";
import { Breadcrumbs } from "../components/breadcrumbs";

const breadcrumbItems = [
  { href: "#", text: "Key Management" },
  { href: "/set-badge-pin", text: "Set Badge PIN" },
];

export const SetBadgePin = () => {
  const auth = useAuth();
  const { setPin, pinError, isPinSuccess, isPinLoading } = useSetBadgePin();

  const alerts: AlertsType = isPinSuccess
    ? {
        successfully_registered_alert: {
          message: RegistrationMessages.BADGE_PIN_SET_SUCCESS,
          ariaLabel: "Success",
          type: "success",
        },
      }
    : {};

  return (
    <PageLayout auth={auth}>
      <ContentLayout
        notifications={<Alerts items={alerts} />}
        breadcrumbs={<Breadcrumbs items={breadcrumbItems} />}
        headerVariant="high-contrast"
        header={<Header variant="h1">Badge PIN Registration</Header>}
        defaultPadding
      >
        <SpaceBetween direction="vertical" size="l">
          <Container header={<Header variant="h2">Set your Badge PIN</Header>}>
            <PinForm
              error={pinError}
              onSubmit={setPin}
              isLoading={isPinLoading}
              {...BADGE_PIN_PRESET}
            />
          </Container>
        </SpaceBetween>
      </ContentLayout>
    </PageLayout>
  );
};
